module.exports = __webpack_public_path__ + "static/Background-969f3da18c832ed8ae79d377f75cb95b.png";